import { render, staticRenderFns } from "./oil-order.vue?vue&type=template&id=dea8ad68&"
import script from "./oil-order.vue?vue&type=script&lang=js&"
export * from "./oil-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports